// AI Generated Component
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { AdminAuditlogComponent } from './admin-auditlog.component';

const states = [
    {
        name: 'base.customer.admin.auditlog',
        url: '/log',
        abstract: true,
        template: '<div ui-view></div>',
        data: { title: 'Acquia Web Governance - Audit Log' },
    },
    {
        name: 'base.customer.admin.auditlog.index',
        url: '?page&search&page_size&module&domain_id&user_id&from&to',
        params: {
            page: { dynamic: true },
            search: { dynamic: true },
            page_size: { dynamic: true },
            module: { dynamic: true },
            domain_id: { dynamic: true },
            user_id: { dynamic: true },
            from: { dynamic: true },
            to: { dynamic: true },
        },
        views: {
            'content@base.customer.admin': {
                component: AdminAuditlogComponent,
            },
        },
        data: {},
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states })],
    exports: [UIRouterModule],
})
export class AuditlogRoutingModule {}
